var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveActivity(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4475 3.66666L4.4275 12.6867L9.31333 17.5725L18.3333 8.5525V3.66666H13.4475ZM12.6867 1.83333H20.1667V9.31333L9.31333 20.1667L1.83333 12.6867L12.6867 1.83333Z",
    fill: "#E71316"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2091 7.18666C13.2091 8.07583 13.9241 8.79082 14.8133 8.79082C15.7024 8.79082 16.4174 8.07583 16.4174 7.18666C16.4174 6.29749 15.7024 5.58249 14.8133 5.58249C13.9241 5.58249 13.2091 6.29749 13.2091 7.18666Z",
    fill: "#E71316"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveActivity);
export default __webpack_public_path__ + "static/media/activeActivity.961674eecda3a88392afac720e2b75ef.svg";
export { ForwardRef as ReactComponent };